import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { ButtonSkeleton } from '../../../button/subcomponents/skeleton';
const b = bemClassBuilder('v-form');
export const FormSkeleton = props => {
    const { className, showButtons, config, children } = props;
    const { submitButton, cancelButton } = config;
    return (_jsxs("div", { className: b.block({ skeleton: true }, className), children: [children, showButtons && (_jsxs("div", { className: b.element('buttons'), children: [cancelButton.show && _jsx(ButtonSkeleton, Object.assign({}, cancelButton, { className: b.element('cancel-button') })), submitButton.show && _jsx(ButtonSkeleton, Object.assign({}, submitButton, { className: b.element('submit-button') }))] }))] }));
};
FormSkeleton.displayName = 'FormSkeleton';
//# sourceMappingURL=skeleton.js.map